"use strict";

// this file is import from webpack config use es5 export and require
// do not change it
const lodash = require('lodash');

function formatInputsAsArray(inputs, CAPTION_FLDS, OUTRO_FLDS, supportOldJson) {
  const inputsArray = [];

  if (!inputs) {
    if (supportOldJson) {
      inputsArray.push('value');
    } else {
      inputsArray.push({ ...CAPTION_FLDS.value,
        name: 'value'
      });
    }
  } else if (lodash.isArray(inputs)) {
    inputs.forEach(input => {
      if (supportOldJson) {
        inputsArray.push(lodash.isString(input) ? input : input.name);
      } else if (lodash.isString(input)) {
        inputsArray.push({ ...OUTRO_FLDS[input],
          name: input
        });
      } else {
        inputsArray.push(input);
      }
    });
  }

  return inputsArray;
}

module.exports = formatInputsAsArray;